// 异步加载组件文件
// const Foo = () => import('./Foo.vue') 这种写法是异步加载
/* webpackChunkName: "PEIJIAN" */ // 这部分不是注释 而是 把文件都打包到 同一个块 里
const Layout = () => import('@/components/layout/index.vue')
const Frame = () => import('@/page/frame/index.vue')
const Policy = () => import('@/page/frame/policy.vue')
const Information = () => import('@/page/information')

export default {
  path: '',
  component: Layout,
  meta: {
    title: 'HOME',
    icon: 'HOME'
  },
  children: [
    { path: '/zhiku/sh', component: Frame, meta: { context: '/client.html' }},
    { path: '/zhiku/sq', component: Frame, meta: { context: '/client.html' }},
    { path: '/zhiku/qd', component: Frame, meta: { context: '/client.html' }},
    { path: '/zhice/cx', component: Frame, meta: { context: '/client.html' }},
    { path: '/zhice/jgcl', component: Frame, meta: { context: '/client.html' }},
    { path: '/zhice/xl', component: Frame, meta: { context: '/client.html' }},
    { path: '/zhiku/double', component: Frame, meta: { context: '/client.html' }},
    { path: '/news', component: Frame, meta: { context: '/client.html' }},

    { path: '/zhiku/prediction', component: Frame, meta: { context: '/salesForecast/index.html' }},
    { path: '/zhiku/ner_xl', component: Frame, meta: { context: '/newEnergy/newEnergy.html' }},
    { path: '/zhiku/car_newEnergy', component: Frame, meta: { context: '/newEnergy2/index.html' }},
    { path: '/zhiku/newcar', component: Frame, meta: { context: '/newCar/newCar.html' }},
    { path: '/zhiku/finance', component: Frame, meta: { context: '/finance/finance.html' }},
    { path: '/zhiku/painlib', component: Frame, meta: { context: '/painPointsLib/painPointsLib.html' }},
    { path: '/zhiku/lifeCircle', component: Frame, meta: { context: '/lifeCircle/index.html' }},

    { path: '/zhiku/policy', component: Policy, meta: { context: '/hangye/index.html' }},
    { path: '/zhiku/enterprise', component: Policy, meta: { context: '/qiye.html' }},

    { path: '/information', name: 'information', component: Information, meta: { keepAlive: true }},

    { path: '/sales-analysis', component: Frame, meta: { context: '/salesPerformance/index.html' }},
    { path: '/reward-tool', component: Frame, meta: { context: '/reward-tool/index.html' }},
    { path: '/big-data', component: Frame, meta: { context: '/big-data/index.html' }},
    { path: '/insight', component: Frame, meta: { context: '/insight/index.html' }},
    { path: '/enterprise', component: Frame, meta: { context: '/enterprise/index.html' }},
    { path: '/model-conf', component: Frame, meta: { context: '/model-conf/index.html' }},
    // chillum 20200414
    { path: '/report/topicReport', name: 'topicReport', component: () => import('@/page/onlineReport/topicReport') },
    { path: '/report/projectReport', name: 'projectReport', component: () => import('@/page/onlineReport/projectReport') },
    { path: '/report/planReport', name: 'planReport', component: () => import('@/page/onlineReport/planReport') },

    { path: '/reward-tool', component: Frame, meta: { context: '/reward-tool/index.html' }}
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/product.js